// OrderbookConfigureColumns.tsx
import { type FC, type Dispatch, type SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { getDefaultColumnConfig } from "./ExportOrderbookColumnConfig";
import { apiUpdateColumnSettings } from "~/features/search/components/ProductResults/views/NewTabularView/ConfigureColumnsButton/apiUpdateColumnSettings";
import type { ColumnData } from "~/features/search/components/ProductResults/views/NewTabularView/ConfigureColumnsButton/ColumnConfigurator";
import { ConfigureColumnsPopover } from "~/features/search/components/ProductResults/views/NewTabularView/ConfigureColumnsButton/ConfigureColumnsPopover";

interface Props {
  columns: ColumnData[];
  setColumns: Dispatch<SetStateAction<ColumnData[]>>;
}

export const OrderbookConfigureColumns: FC<Props> = ({
  columns,
  setColumns,
}) => {
  const { t } = useTranslation();
  const headerT = (k: string) => t(`page.abmonitor.tableHeader.${k}`);

  const handleSave = (draft: ColumnData[]) => {
    apiUpdateColumnSettings(draft, false, true);
    setColumns(draft);
  };

  const handleReset = () => {
    const reset = getDefaultColumnConfig(headerT);
    const trimmed = reset.filter(
      (c) => !["salesOrderNo", "purchaseOrderNo", "actions"].includes(c.code),
    );
    apiUpdateColumnSettings(trimmed, false, true);
    setColumns(trimmed);
    return trimmed;
  };

  return (
    <ConfigureColumnsPopover
      buttonLabel={t("page.abmonitor.tableFooter.manageColumns")}
      initialColumns={columns}
      onSave={handleSave}
      onReset={handleReset}
      headerT={headerT}
    />
  );
};
